import React from "react";
import i18n from "../../config/languageInit";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk");
    return { hasError: true, isChunkError };
  }

  handleRetry = () => {
    if (this.state.isChunkError) {
      window.location.reload();
    } else {
      this.setState({ hasError: false, isChunkError: false });
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "50vh",
          gap: "1rem",
          padding: "2rem",
          textAlign: "center",
          color: "var(--text-primary)",
        }}>
          <h2 style={{ margin: 0 }}>
            {this.state.isChunkError
              ? i18n.t("error_loading_page")
              : i18n.t("error")}
          </h2>
          <p style={{ color: "var(--text-secondary)", margin: 0 }}>
            {this.state.isChunkError
              ? i18n.t("error_chunk_description")
              : i18n.t("error_generic_description")}
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: "0.625rem 1.5rem",
              borderRadius: "var(--radius-sm)",
              border: "1px solid var(--accent-blue)",
              background: "var(--accent-blue)",
              color: "#fff",
              cursor: "pointer",
              fontSize: "0.875rem",
              fontWeight: 500,
            }}
          >
            {i18n.t("retry")}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
